<template>
  <div class="d-flex fill-height pa-6 pt-4 flex-column">
    <div class="d-flex justify-space-between pb-2 grow-shrink-0 flex-grow-0 pb-0">
      <div class="title">
          <v-edit-dialog
            :return-value.sync="editor.query.name"
            @open="editor.old_query.name = editor.query.name"
            @save="ApplyEditName"
          >
            <v-tooltip top>
              <template v-slot:activator="{ on }">
                <div
                  class="editable-title text-truncate  pl-2 pr-8"
                  :class="[(editor.query.name=='') ? 'grey--text' : '']"
                  v-on="on"
                >
                  {{ (editor.query.name!='') ? editor.query.name : 'Type your query\'s name here...' }}
                  <v-icon
                    class="edit-icon"
                    small
                    :color="(editor.query.name != '') ? 'primary' : 'grey'"
                  >
                    mdi-circle-edit-outline
                  </v-icon>
                </div>
              </template>
              <span>Click to edit</span>
            </v-tooltip>

            <template v-slot:input>
              <v-text-field
                v-model="editor.query.name"
                label="Query's title"
                placeholder="Enter query title..."
                single-line
              />
            </template>
          </v-edit-dialog>
        </div>
        <div class="controls">
          <v-btn
          v-if="editor.query.id"
          class="float-right"
          text
          outlined
          color="red"
          @click="deleteQuery"
        >
          <v-icon left>
            mdi-delete-outline
          </v-icon>
          Delete
        </v-btn>
        <v-btn
          v-if="editor.query.id"
          class="float-right mr-2"
          text
          outlined
          color="blue"
          @click="cloneQuery"
        >
          <v-icon left>
            mdi-content-duplicate
          </v-icon>
          clone
        </v-btn></div> 
    </div>
    <div class="d-flex flex-grow-1">
              <multipane
          class="vertical-panes fill-height"
          layout="vertical"
        >
          <div
            class="pane"
            :style="{
              minWidth: '20%',
              width: '20%',
              maxWidth: '30%'
            }"
            style="border-right: 1px solid gainsboro;"
          >
            <multipane
              class="horizontal-panes fill-height"
              layout="horizontal"
              
            >
              <div
                class="pane"
                :style="{ minHeight: '10%', maxHeight: '90%' }"
                style="border-bottom: 1px solid gainsboro;"
              >
                <!-- TOP LEFT -->
                <v-row class="pt-0 fill-height">
                  <input
                    v-model="search"
                    type="text"
                    placeholder="Search datasets, fields..."
                    class="hmd_search_datasets_input"
                  >
                  <v-col
                    cols="12"
                    class=" fill-height hmd_dataset_list"
                  >
                    <v-treeview
                      dense
                      hoverable
                      :items="datasets"
                      :search="search"
                      item-children="fields"
                    >
                      <template
                        v-slot:label="{ item, leaf }"
                      >
                        <span
                          @click="
                            selectedField(
                              item,
                              leaf
                            )
                          "
                        >
                          {{ item.name }}
                        </span>
                      </template>
                      <template
                        v-slot:prepend="{ item, leaf }"
                      >
                        <template v-if="leaf">
                          <v-icon>
                            mdi-{{ fieldTypeIcon(item) }}
                          </v-icon>
                        </template>
                        <v-icon
                          v-else
                          small
                        >
                          mdi-table
                        </v-icon>
                      </template>
                    </v-treeview>
                  </v-col>
                </v-row>
              </div>
              <multipane-resizer class="horizontal" />
              <div
                class="pane"
                :style="{
                  flexGrow: 1,
                  minHeight: '10%',
                  maxHeight: '90%'
                }"
                style="border-bottom: 1px solid gainsboro;"
              >
                <!-- BOTTOM LEFT -->
                <div class="hmd_visualizations_list_header">
                  <span>Visualizations</span>
                  <element-builder
                    :data="data"
                    :btn-class="'float-right'"
                    @create="createVisualization"
                  >
                    <v-icon>mdi-plus</v-icon>
                  </element-builder>
                </div>
                <v-col
                  cols="12"
                  class="fill-height pt-10"
                >
                  <v-list
                    class="fill-height"
                    :style="{ overflow: 'auto' }"
                  >
                    <v-list-item-group
                      v-model="selectedVisualisationIndex"
                      color="primary"
                      mandatory
                    >
                      <v-list-item
                        v-for="(item,
                                i) in visualizations"
                        :key="i"
                      >
                        <v-list-item-content>
                          <span>
                            <v-icon
                              class="viz_icon"
                            >
                              {{
                                decideElementIcon(
                                  item.type
                                )
                              }}
                            </v-icon>
                            {{ item.label }}
                            <v-btn
                              v-if="
                                !item.is_default
                              "
                              class="float-right"
                              icon
                              small
                              depressed
                              @click.stop="
                                deleteVisualization(
                                  item
                                )
                              "
                            >
                              <v-icon>mdi-delete-outline</v-icon>
                            </v-btn>
                          </span>
                        </v-list-item-content>
                      </v-list-item>
                    </v-list-item-group>
                  </v-list>
                </v-col>
              </div>
            </multipane>
          </div>
          <multipane-resizer
            class="vertical"
            :style="{height : windowHeight + 'px'}"
          />
          <div
            class="
            pane"
            :style="{ flexGrow: 1 }"
          >
            <multipane
              class="horizontal-panes"
              layout="horizontal"
              style="height:100%"
            >
              <div
                class="pane"
                :style="{ minHeight: '30%', maxHeight: '90%' }"
                style="border-bottom: 1px solid gainsboro;"
              >
                <v-row class="fill-height d-flex flex-column pb-11">
                  <v-col
                  
                    cols="12"
                    class="pa-0 d-flex flex-shrink-1 flex-grow-1 overflow-auto"
                  >
                    <editor
                      :id="editorId"
                      v-model="editor.query.query"
                      class="fill-height"
                      :value="editor.query.query"
                      :show-print-margin="false"
                      :options="editor.options"
                      theme="chrome"
                      lang="sql"
                      width="100%"
                      height="100%"
                      @init="editorInit"
                    />
                  </v-col>
                  <div class="hmd_editor_controls d-flex flex-shrink-0 flex-grow-0">
                    <v-row
                      class="pa-0"
                      justify="space-between"
                    >
                      <v-col
                        cols="4"
                        class="pa-0"
                      >
                        <v-tooltip
                          top
                          class="d-inline-block"
                        >
                          <template
                            v-slot:activator="{
                              on
                            }"
                          >
                            <v-btn
                              style="min-width:50px;"
                              depressed
                              small
                              @click="formatQuery"
                              v-on="on"
                            >
                              <v-icon
                                style="font-size:17px;"
                              >
                                mdi-format-indent-increase
                              </v-icon>
                            </v-btn>
                          </template>
                          <span>Format code</span>
                        </v-tooltip>
                        <v-tooltip
                          top
                          class="d-inline-block ml-4"
                        >
                          <template
                            v-slot:activator="{
                              on
                            }"
                          >
                            <v-btn
                              :color="
                                editor.options
                                  .enableLiveAutocompletion
                                  ? 'primary'
                                  : 'grey lighten-3'
                              "
                              style="min-width:50px;"
                              depressed
                              small
                              v-on="on"
                              @click="
                                editor.options.enableLiveAutocompletion = !editor
                                  .options
                                  .enableLiveAutocompletion;
                                applyEditorOptions();
                              "
                            >
                              <v-icon
                                style="font-size:17px;"
                              >
                                mdi-flash
                              </v-icon>
                            </v-btn>
                          </template>
                          <span>Autocomplete
                            Enabled</span>
                        </v-tooltip>
                      </v-col>
                      <v-col
                        cols="8"
                        class="text-right pa-0"
                      >
                        <v-tooltip
                          top
                          class="d-inline-block mr-4"
                        >
                          <template
                            v-slot:activator="{
                              on
                            }"
                          >
                            <v-btn
                              small
                              :loading="
                                loaders.saving
                              "
                              v-on="on"
                              @click="save"
                            >
                              <v-icon
                                small
                                left
                              >
                                mdi-content-save-outline
                              </v-icon>
                              Save
                              {{
                                isReadyToSave
                                  ? "*"
                                  : ""
                              }}
                              <template
                                v-slot:loader
                              >
                                <span>Saving...</span>
                              </template>
                            </v-btn>
                          </template>
                          <span>CTRL + S</span>
                        </v-tooltip>
                        <v-tooltip
                          top
                          class="d-inline-block"
                        >
                          <template
                            v-slot:activator="{
                              on
                            }"
                          >
                            <v-btn
                              color="primary"
                              small
                              depressed
                              :disabled="
                                !loaders
                                  .executing
                                  .finished
                              "
                              v-on="on"
                              @click="exec"
                            >
                              <v-icon left>
                                mdi-play
                              </v-icon>
                              Execute
                              <template
                                v-slot:loader
                              >
                                <span>Executing...</span>
                              </template>
                            </v-btn>
                          </template>
                          <span>CTRL + Enter</span>
                        </v-tooltip>
                      </v-col>
                    </v-row>
                  </div>
                </v-row>
              </div>
              <multipane-resizer class="horizontal" />
              <!-- Query Param here -->
              <div v-if="Object.keys(parameters).length > 0">
                  <query-param-entry
                  v-for="(param, i) in parameters"
                  :key="param.name"
                    v-model="parameters[i]"
                    class="pa-0 mx-4 my-2 mt-0 d-inline-block"
                    style="max-width:250px"
                  />
              </div>
              <div
                class="pane"
                :style="{ flexGrow: 1 }"
                style="border-bottom: 1px solid gainsboro;"
              >
                <v-row
                  style="height:100%;width:100%;margin:0px;"
                >
                  <v-col
                    cols="12"
                    class="pa-0 fill-height"
                    style="overflow:auto"
                  >
                    <v-alert
                      v-if="
                        !loaders.executing.finished &&
                          loaders.executing.start !=
                          null
                      "
                      :value="true"
                      text
                      color="teal"
                    >
                      Executing query...
                      {{ loaders.executing.duration }}
                    </v-alert>
                    <template
                      v-else-if="
                        !_.isEmpty(editor.execErrors)
                      "
                    >
                      <v-alert
                        v-for="(err_body,
                                err_label,
                                err_index) in typeof editor.execErrors ==
                                  'string'
                                  ? [editor.execErrors]
                                  : editor.execErrors"
                        :key="err_index"
                        :value="true"
                        text
                        type="error"
                      >
                        Error running query :
                        {{ err_body }}
                      </v-alert>
                    </template>
                    <dashboard-element
                      v-else-if="selectedVisualisation"
                      fill-parent
                      depressed
                      :editable="
                        !selectedVisualisation.is_default
                      "
                      :removable="
                        !selectedVisualisation.is_default
                      "
                      :element="selectedVisualisation"
                      @remove="
                        deleteVisualization(
                          selectedVisualisation
                        )
                      "
                      @edit="updateVisualization"
                    />
                  </v-col>
                </v-row>
              </div>
            </multipane>
          </div>
          </multipane-resizer>
        </multipane>
    </div>
  </div>
</template>

<script>
  import DashboardElement from './../../../../UIComponents/Dashboard/Element'
  import HELPER from './helpers/helper'
  import QUERY_1 from './data/query_2.json'
  import { VIZ_CONFIGS } from './../../../../UIComponents/Dashboard/constants/VisualizationConfigs'
  import { Multipane, MultipaneResizer } from 'vue-multipane-combined'
  import ElementBuilder from './../../../../UIComponents/Dashboard/ElementBuilder'
  import QueryParamEntry from '@/components/Dashboard/Views/Projects/Queries/QueryParamEntry'

  import QueryService from './services/QueryService'
  import DatasetService from '../../Datastore/services/DatasetService'
  import ProjectService from './../services/ProjectService'
  import VisualizationService from './services/VisualizationService'
  import sqlFormatter from 'sql-formatter'

  export default {
    name: 'QueryBuilder',
    components: {
      'dashboard-element': DashboardElement,
      'element-builder': ElementBuilder,
      editor: require('vue2-ace-editor'),
      multipane: Multipane,
      'multipane-resizer': MultipaneResizer,
      QueryParamEntry,
    },
    mixins: [HELPER],
    props: {
      identifier: {
        type: String,
        default: null,
      },
    },
    data () {
      return {
        editorId: 'query-editor-' + _.uniqueId(),
        execHistory: [],
        project: {
          id: this.$route.params.project || '',
        },
        loaders: {
          saving: false,
          executing: {
            init: false,
            start: null,
            duration: '00:00:00',
            timer: null,
            finished: true,
          },
        },
        height: window.innerHeight,
        datasets: [
          {
            name: 'test',
            isDataset: true,
            fields: [
              {
                name: 'Hello',
                isPrimaryKey: true,
                type: 'Number',
              },
            ],
          },
        ],
        search: '',
        editor: {
          old_query: {
            id: this.$route.params.query || null,
            name: 'untitled-query',
            query: '',
          },
          query: {
            id: this.$route.params.query || null,
            name: 'untitled-query',
            query: '',
            visualizations: [],
          },
          execErrors: {},
          options: {
            enableBasicAutocompletion: true,
            enableSnippets: true,
            enableLiveAutocompletion: true,
            showPrintMargin: false,
            showLineNumbers: false,
            tabSize: 2,
            maxLines: Infinity,
          },
        },
        data: {
          columns: [],
          rows: [],
        },
        selectedVisualisationIndex: 0,
        now: this.$moment(),
        // windowHeight: window.innerHeight,

        parameters: [],
      }
    },
    computed: {

      isReadyToSave () {
        const qOld = this.editor.old_query
        const q = this.editor.query
        const isReady = q.id != qOld.id || q.query != qOld.query
        this.$emit(
          'updateCloseConstraint',
          isReady
            ? 'Are you sure you want to quit without saving ?'
            : null
        )
        return isReady
      },
      isReadyToExec () {
        // if(this.editor.query.query=='')
        //     return false
        // if(this.execHistory.length<=0)
        //     return true
        // let q = this.editor.query
        // let last_q = this.execHistory[this.execHistory.length-1]

        // return q.query.replace(' ','') != last_q.query.replace(' ','')
        return true
      },
      visualizations () {
        return this.editor.query.visualizations
      },
      // filteredDatasets() {
      //     if (datasets.length <= 0)
      //         return []
      //     return []
      // },
      selectedVisualisation () {
        if (this.editor.query.visualizations.length <= 0) {
          return null
        }
        const el = _.cloneDeep(
          this.visualizations[this.selectedVisualisationIndex]
        )
        el.data = this.data
        return el
      },
      // execTime() {
      //     if (this.loaders.executing.end == null)
      //         return null
      //     let start = this.loaders.executing.start
      //     return this.now

      // },
      code () {
        return this.editor.query.query
      },
      windowHeight () {
        /**
         * Determine how height the window need
         * to be to let the result data readable with all the parameter
         *
         * On LG result are still readable with 1 row of parameters ( 6 ), need to be heigher after that
         * On md result are not readable with 1 row of parameters
         * On sm result are not readable with 1 row of parameters
         */
        let neededHeight = this.$vuetify.breakpoint.height
        const stepHeight = 190
        const nbParams = this.getParameters().length
        const nbParamsPerRowSm = 2
        const nbParamsPerRowMd = 3
        const nbParamsPerRowLg = 6
        let nbRow = 0

        switch (this.$vuetify.breakpoint.name) {
          case 'xs':
          case 'sm':
            nbRow = Math.ceil(nbParams / nbParamsPerRowSm)
            neededHeight += stepHeight * nbRow
            break
          case 'md':
            nbRow = Math.ceil(nbParams / nbParamsPerRowMd)
            neededHeight += stepHeight * nbRow
            break
          case 'lg':
          case 'xl':
            nbRow = Math.ceil(nbParams / nbParamsPerRowLg)
            nbRow -= 1 // Because it is still readable with 1 row of parameter
            neededHeight += stepHeight * nbRow
            break
        }

        return neededHeight
      },
    },
    watch: {
      code () {
        this.cleanArguments(this.getParameters())
      },
    },
    mounted () {
      const self = this

      document.addEventListener(
        'keydown',
        function (e) {
          if (
            (window.navigator.platform.match('Mac')
              ? e.metaKey
              : e.ctrlKey) &&
            e.keyCode == 83
          ) {
            e.preventDefault()
          }
          if (e.ctrlKey) {
            switch (e.keyCode) {
              case 13:
                if (!self.loaders.executing.finished) {
                  return
                }
                self.exec()
                break
              case 83:
                e.preventDefault()
                if (self.isReadyToSave) {
                  self.save()
                }
                break
            }
          }
          return false
        },
        false
      )
      ProjectService.get(self, self.$route.params.project)
        .then(r => {
          self.project = r.data
          self.getDatasets()
          // self.exec()
        })
        .catch(err => {
          self.$router.replace('/notfound')
          console.log(err)
        })
      this.getQuery()
      _.delay(() => {
        self.$editor = window.ace.edit(self.editorId)
        self.$editor.setOptions(self.editor.options)
      }, 300)
    },
    methods: {
      fieldTypeIcon (item) {
        if (item.primary_key) { return 'key-variant' }
        switch (item.type) {
          case 'text':
          case 'ascii':
          case 'uuid':
            return 'alpha-t-box-outline'
          case 'date':
          case 'timestamp':
            return 'calendar-month-outline'
          case 'number':
          case 'float':
          case 'bigint':
          case 'int':
            return 'numeric'
          case 'boolean':
            return 'order-bool-descending-variant'
          default:
            break
        }
        return 'help-circle-outline'
      },
      cleanArguments (newArgs) {
        // Create a list with already existing parameters' name
        const alreadyExistingNames = _.map(this.parameters, 'name')

        // Check if we need to add a parameter
        for (let i = 0; i < newArgs.length; i++) {
          if (!(alreadyExistingNames.includes(newArgs[i]))) {
            const param = { value: '', type: 'Text', name: newArgs[i] }
            this.parameters.push(param)
          }
        }

        // Check if we need to remove a parameter
        this.parameters = this.parameters.filter(p => {
          return newArgs.includes(p.name)
        })
      },
      getParameters () {
        const code = this.editor.query.query
        const args = []

        // Detect how many args there are
        const argsBuff = [...code.matchAll(/{{[ ]*(\w+)[ ]*}}/g)]
        for (const arg of argsBuff) {
          args.push(arg[1])
        }

        return args
      },
      ApplyEditName () {
        if (this.editor.query.id == null) { return this.save() }

        const self = this
        if (!self.editor.query.name) {
          self.editor.old_query.name = _.clone(self.editor.query.name)
          return
        }
        QueryService.patch(self, self.editor.old_query, self.editor.query)
          .then(res => {
            self.$store.commit('push', {
              msg: "Query's name updated",
              color: 'secondary',
            })
            self.editor.old_query.name = _.clone(self.editor.query.name)
            self.editor.old_query.query = self.editor.query.query
          })
          .catch(err => {
            console.log(err)
            self.editor.query.name = _.clone(
              self.editor.old_query.name
            )
          })
      },
      close () {
        const self = this
        _.delay(() => {
          self.$emit('close')
        }, 300)
      },
      addEditorCompletions (wordList, meta) {
        this.$editor.completers.push({
          getCompletions: function (
            editor,
            session,
            pos,
            prefix,
            callback
          ) {
            callback(
              null,
              wordList.map(function (word) {
                return {
                  caption: word,
                  value: word,
                  meta: meta || 'static',
                }
              })
            )
          },
        })
      },
      formatQuery () {
        this.editor.query.query = sqlFormatter.format(
          this.editor.query.query
        )
      },
      applyEditorOptions () {
        this.$editor.setOptions(this.editor.options)
      },
      selectedField (item, leaf) {
        this.$editor.session.insert(
          this.$editor.getCursorPosition(),
          item.name
        )
        this.$editor.focus()
      },
      getDatasets () {
        const self = this
        DatasetService.listDetailsProjects(this, this.project).then(
          res => {
            self.datasets = res.data.results
            this.addEditorCompletions(
              _.map(self.datasets, 'name'),
              'table'
            )
            this.addEditorCompletions(
              _.map(
                _.flatten(_.map(self.datasets, 'fields')),
                'name'
              ),
              'column'
            )
          }
        )
      },
      handleTimer (start) {
        const self = this
        if (start) {
          self.loaders.executing.finished = false
          self.loaders.executing.start = self.$moment()
          self.loaders.executing.timer = setInterval(() => {
            const duration = self.$moment.duration(
              self.$moment().diff(self.loaders.executing.start)
            )
            self.loaders.executing.duration = `${
              duration.hours() > 9 ? '' : '0'
            }${duration.hours()}:${
              duration.minutes() > 9 ? '' : '0'
            }${duration.minutes()}:${
              duration.seconds() > 9 ? '' : '0'
            }${duration.seconds()}`
          }, 1000)
        } else {
          clearInterval(self.loaders.executing.timer)
          self.loaders.executing.start = null
          self.loaders.executing.duration = '00:00:00'
          self.loaders.executing.finished = true
        }
      },
      exec () {
        const self = this
        if (!self.isReadyToExec) {
          return
        }
        self.handleTimer(true)
        QueryService.exec(self, self.editor.query, self.project.id, self.parameters)
          .then(res => {
            if (res.data.error) {
              self.editor.execErrors = res.data.error
              self.loaders.executing.init = true
              return
            }
            self.execHistory.push({
              id: _.cloneDeep(self.editor.query.id),
              query: _.cloneDeep(self.editor.query.query),
              executedAt: self.$moment().format('YYYY-MM-DD HH:mm:ss'),
            })
            self.editor.execErrors = {}
            self.loaders.executing.init = true
            self.$set(self, 'data', res.data.data)
            self.patchDefaultTableOptions(res.data.data)
          })
          .catch(err => {
            if (err) {
              if (err.response) {
                self.editor.execErrors = err.response.data
              }
            }
          })
          .finally(() => {
            self.handleTimer(false)
          })
      },
      async deleteVisualization (viz) {
        const self = this
        this.$store.commit('confirm', {
          message: 'Do you really want to delete this visualization ?',
          title: 'Warning',
          color: 'warning',
          onCancel: () => {},
          onConfirm: () => {
            if (viz.id) {
              VisualizationService.delete(self, viz).then(res => {
                self.selectedVisualisationIndex = 0
                self.editor.query.visualizations.splice(
                  self.editor.query.visualizations.indexOf(viz),
                  1
                )
              })
            } else {
              self.selectedVisualisationIndex = 0
              self.editor.query.visualizations.splice(
                self.editor.query.visualizations.indexOf(viz),
                1
              )
            }
          },
        })
      },
      save () {
        const self = this
        self.loaders.saving = true
        if (self.editor.query.id) {
          QueryService.update(
            this,
            this.editor.old_query,
            this.editor.query,
            this.parameters
          )
            .then(res => {
              if (res.data.id != self.editor.old_query.id) {
                self.$emit('create', res.data)
                return
              }
              self.editor.query.label = res.data.label
              self.editor.query.query = res.data.query
              self.editor.query.updated_at = res.data.updated_at
              self.editor.old_query = _.cloneDeep(self.editor.query)
            })
            .finally(() => {
              self.loaders.saving = false
            })
        } else {
          QueryService.create(this, this.editor.query, this.project.id, this.parameters)
            .then(res => {
              self.editor.query = res.data
              self.editor.old_query = _.cloneDeep(self.editor.query)
              self.$emit('create', res.data)
            })
            .finally(() => {
              self.loaders.saving = false
            })
        }
      },
      patchDefaultTableOptions (data) {
        const self = this
        const vizs = self.editor.query.visualizations
        const index = vizs.findIndex(o => {
          return o.is_default
        })
        if (index >= 0) {
          if (_.isEmpty(vizs[index].options)) {
            const options = VIZ_CONFIGS.table
            options.Columns['Column Parameters'].columns = self.getHeader(data.columns)
            vizs[index].options = options
          } else {
            vizs[index].options.Columns['Column Parameters'].columns = self.getHeader(data.columns)
          }
        } else {
          const options = VIZ_CONFIGS.table
          options.Columns['Column Parameters'].columns = self.getHeader(data.columns)
          self.editor.query.visualizations.push({
            label: 'Query results',
            type: 'table',
            is_default: true,
            options: options,
          })
        }
      },
      updateVisualization (viz) {
        const self = this
        VisualizationService.update(this, viz).then(res => {
          if (res) {
            const foundIndex = self.editor.query.visualizations.findIndex(
              o => {
                return o.id == viz.id
              }
            )
            if (foundIndex >= 0) {
              this.$set(
                self.editor.query.visualizations,
                foundIndex,
                res.data
              )
            }
          }
        })
      },
      createVisualization (viz) {
        const self = this
        self.loaders.saving = true
        if (self.editor.query.id) {
          VisualizationService.create(self, self.editor.query, viz)
            .then(res => {
              if (res) {
                self.editor.query.visualizations.push(res.data)
                self.selectedVisualisationIndex =
                  self.editor.query.visualizations.length - 1
              }
            })
            .finally(() => {
              self.loaders.saving = false
            })
        } else {
          self.editor.query.visualizations.push(viz)
        }
      },
      editorInit () {
        require('brace/theme/chrome')
        require('brace/mode/sql')
        require('brace/ext/beautify')
        require('brace/ext/language_tools')
      },
      async cloneQuery () {
        const self = this
        const projects = await ProjectService.list(this).then(r => {
          return _.map(r.data.results, 'name')
        })
        this.$store.commit('confirm', {
          message: 'Do you really want to clone this query ?',
          title: 'Warning',
          color: 'warning',
          form: {
            clone_name: {
              type: 'text',
              label: 'New query name',
              placeholder: "New query's name",
            },
            target_project: {
              type: 'select',
              values: projects,
              label: 'Target project',
              placeholder: 'Choose a target project',
              required: true,
            },
          },
          onCancel: () => {},
          onConfirm: (args) => {
            ProjectService.list(self).then((result) => {
              // Retrieve project id
              let myPg = _.pickBy(result.data.results, { name: args.target_project })
              if (Object.keys(myPg).length > 0) {
                myPg = myPg[Object.keys(myPg)[0]].id
                QueryService.clone(self, self.editor.query, myPg, args.clone_name)
              }
            })
          },
        })
      },
      deleteQuery () {
        const self = this
        this.$store.commit('confirm', {
          message: 'Do you really want to delete this query ?',
          title: 'Warning',
          color: 'warning',
          onCancel: () => {},
          onConfirm: () => {
            QueryService.delete(self, self.editor.query.id).then(
              () => {
                self.$emit('delete')
                self.close()
              }
            )
          },
        })
      },
      getQuery () {
        const self = this
        const queryId = self.identifier || self.$route.params.query
        if (queryId) {
          QueryService.get(self, {
            id: queryId,
          })
            .then(res => {
              self.editor.query = res.data
              self.editor.old_query = _.cloneDeep(self.editor.query)
              self.parameters = res.data.parameters
              self.exec()
            })
            .catch(function (err) {
              self.$router.replace('/notfound')
            })
            .finally(() => {
              self.loaders.saving = false
            })
        }
      },
    },
  }
</script>

<style scoped>
.pb-7 {
    padding-bottom: 85px;
}
.multipane-resizer.horizontal {
    height: 15px;
}
.multipane-resizer.vertical {
    width: 15px;
}
.multipane-resizer {
    transition: 0.3s all;
}

.multipane-resizer:hover {
    background: #efefef;
    transition: 0.3s all;
}

.vertical-panes {
    width: 100%;
    height: 100% !important;
    border: 1px solid gainsboro;
    border-radius: 4px;
}

.vertical-panes > .pane {
    text-align: left;
    overflow: hidden;
}

.vertical-panes > .pane ~ .pane {
}

.horizontal-panes {
    width: 100%;
    min-height: 600px;
}

.horizontal-panes > .pane {
    text-align: left;
    overflow: hidden;
}

.horizontal-panes > .pane ~ .pane {
}

.layout-v > .multipane-resizer {
    left: 0px !important;
}

.layout-h > .multipane-resizer {
    top: 0px !important;
}

.v-tabs__div {
    background: white;
}

.viz_icon {
    font-size: 18px;
    margin-right: 10px;
}
[role="listitem"].active i {
    color: white;
}
[role="listitem"].active {
    background-color: #3ba99c;
    color: white;
}
.hmd_editor_controls {
    padding: 7px 34px 0px 34px;
    width: 100%;
    height: 44px;
    bottom: 0;
    left: 0;
    position: absolute;
}
.hmd_dataset_list {
    overflow: auto;
    margin-top: 36px;
    padding-bottom: 49px;
    padding-left: 20px;
    padding-right: 20px;
    padding-top: 20px;
}
.hmd_visualizations_list_header {
    position: absolute;
    width: 100%;
    padding: 9px 20px 0px 20px;
}
.hmd_search_datasets_input {
    height: 49px;
    position: absolute;
    padding-top: 0px;
    left: 0px;
    top: 0;
    width: 100%;
    padding: 0px 20px;
    border-bottom: 1px solid #b9b9b9;
    background: #fafafa;
    z-index: 2;
}
.editable-title {
    border-radius: 5px;
}
.editable-title:hover {
    background-color: #213c643b;
    transition: 1s background;
}
.editable-title {
    max-width: 100%;
    position: relative;
    display: inline-block;
}
.v-small-dialog__activator__content {
    width: 100%;
}
i.edit-icon {
    position: absolute;
    right: 5px;
    top: 14px;
}
.multipane-resizer.vertical{
  height:100% !important;
}
</style>
